import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=6be81451&scoped=true&lang=pug&"
import script from "./CreateEventDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateEventDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEventDialog.vue?vue&type=style&index=0&id=6be81451&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be81451",
  null
  
)

export default component.exports